import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DateTools, IconButton, Loader, Tooltip, Utils } from '@treezor/design-system';

import { TWalletOperation } from '@/features/wallets/store/models/walletOperation.model';
import { useAppSelector } from '@/hooks/redux-helpers';
import { selectProofOfPayout } from '@/store/selectors';

interface IWalletOperationActionProps {
  userId: number;
  downloadProofOfPayout: (operation: TWalletOperation) => void;
  operation: TWalletOperation;
}

export function WalletOperationActions({ userId, operation, downloadProofOfPayout }: IWalletOperationActionProps) {
  const { t } = useTranslation();

  const [isProofOfPayoutDownloaded, setIsProofOfPayoutDownloaded] = useState(false);

  const proofOfPayoutState = useAppSelector(
    (state) => selectProofOfPayout(state, userId, operation.walletId, operation.objectId)?.proofOfPayout,
  );

  useEffect(() => {
    if (proofOfPayoutState?.state && isProofOfPayoutDownloaded) {
      Utils.downloadFile(proofOfPayoutState.state.link, `Proof_of_payout${DateTools.format(DateTools.now(), 'file')}`);
    }
  }, [isProofOfPayoutDownloaded, proofOfPayoutState?.state]);

  return proofOfPayoutState?.isLoading ? (
    <Loader />
  ) : (
    <Tooltip
      messageContent={t('pages.currentProfiles.wallets.operations.proofOfPayout.download')}
      contentClassName="w-[250px]"
    >
      <IconButton
        variant="secondary"
        icon="file_save"
        onClick={() => {
          downloadProofOfPayout(operation);
          setIsProofOfPayoutDownloaded(true);
        }}
        testId="wallet-operation-download-proof-of-payout"
      />
    </Tooltip>
  );
}
